export const clearAuthStorage = (): void => {
  try {
    localStorage.removeItem("authToken");
    localStorage.removeItem("tokenExpires");
    localStorage.removeItem("tokenHasExpired");
    localStorage.removeItem("user");
  } catch {
    // ignore
  }

  try {
    sessionStorage.removeItem("authToken");
  } catch {
    // ignore
  }
};

export const redirectToLoginPage = (): void => {
  if (typeof window === "undefined") return;

  const currentPath = window.location?.pathname || "";
  if (currentPath.toLowerCase() === "/login") return;

  window.location.assign("/login");
};

export const handleAuthFailureStatus = (status?: number): boolean => {
  if (status !== 401 && status !== 403) return false;

  clearAuthStorage();
  redirectToLoginPage();
  return true;
};
